import {
  Alert,
  Button,
  Card,
  Checkbox,
  Dialog,
  Field,
  Spinner,
  Stack,
  Table,
  Text,
} from "@chakra-ui/react";

import EfakturaSvg from "./EfakturaSvg";
import { useUserProfile } from "../../../hooks/useUserProfile";
import { useState } from "react";

export default function IssuerModal() {
  const { isLoading, data } = useUserProfile();
  const [open, setOpen] = useState(false);

  return (
    <>
      <Card.Root width={250}>
        <Card.Header display="flex" justifyContent="center" h={75}>
          <EfakturaSvg width={150} />
        </Card.Header>
        <Card.Body>
          <Text>Opprett utstederavtale for efaktura her</Text>
        </Card.Body>
        <Card.Footer>
          <Button
            onClick={() => setOpen(true)}
            colorPalette="blue"
            variant="solid"
            disabled={true}
          >
            Kommer snart!
          </Button>
        </Card.Footer>
      </Card.Root>

      <Dialog.Root open={open} onOpenChange={(e) => setOpen(e.open)}>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content>
            <Dialog.Header>Opprett utstederavtale</Dialog.Header>
            <Dialog.CloseTrigger />
            <Dialog.Body>
              <Stack>
                {isLoading && <Spinner />}
                {!isLoading && (
                  <>
                    <Table.Root>
                      <Table.Body>
                        <Table.Row>
                          <Table.Cell>Organisasjonsnummer</Table.Cell>
                          <Table.Cell>{data?.orgNumber}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell>Bedriftsnavn</Table.Cell>
                          <Table.Cell>{data?.companyName}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell>Kontonummer</Table.Cell>
                          <Table.Cell>
                            {
                              data?.bankAccounts?.filter((x) => x.isPrimary)?.[0]
                                ?.bankAccountNumber
                            }
                          </Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell>E-post</Table.Cell>
                          <Table.Cell>{data?.email}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell>By</Table.Cell>
                          <Table.Cell>{data?.billingCity}</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.Cell>Postnummer</Table.Cell>
                          <Table.Cell>{data?.billingPostalCode}</Table.Cell>
                        </Table.Row>
                      </Table.Body>
                    </Table.Root>
                    <Alert.Root status="warning">
                      <Stack>
                        <Stack direction="row">
                          <Alert.Indicator />
                          <Alert.Title>Eksisterende avtale!</Alert.Title>
                        </Stack>
                        <Alert.Description>
                          Vi fant en utstederavtale på X med status Y
                        </Alert.Description>
                      </Stack>
                    </Alert.Root>
                  </>
                )}
              </Stack>
            </Dialog.Body>

            <Dialog.Footer>
              <Stack>
                <Field.Root>
                  <Stack direction="row" alignItems="flex-start">
                    <Checkbox.Root colorPalette="red" size="lg">
                      <Checkbox.HiddenInput />
                      <Checkbox.Control />
                    </Checkbox.Root>
                    <Field.Label>
                      Jeg er sikker på at jeg ønsker å overskrive eksisterende
                      avtale
                    </Field.Label>
                  </Stack>
                </Field.Root>
                <Stack direction="row">
                  <Button colorPalette="red" disabled={true}>
                    Overskriv
                  </Button>
                  <Button colorPalette="blue" mr={3} onClick={() => setOpen(false)}>
                    Lukk
                  </Button>
                </Stack>
              </Stack>
            </Dialog.Footer>
          </Dialog.Content>
        </Dialog.Positioner>
      </Dialog.Root>
    </>
  );
}
